var map = {
	"./author-manage/author-manage.module": [
		"./src/app/business-module/author-manage/author-manage.module.ts",
		"common",
		"author-manage-author-manage-module"
	],
	"./business-module/business.module": [
		"./src/app/business-module/business.module.ts",
		"default~business-module-business-module~e-commerce-management-e-commerce-module",
		"common",
		"business-module-business-module"
	],
	"./business-module/login/login.module": [
		"./src/app/business-module/login/login.module.ts",
		"business-module-login-login-module"
	],
	"./e-commerce-management/e-commerce.module": [
		"./src/app/business-module/e-commerce-management/e-commerce.module.ts",
		"default~business-module-business-module~e-commerce-management-e-commerce-module",
		"common",
		"e-commerce-management-e-commerce-module"
	],
	"./evaluate/evaluate.module": [
		"./src/app/business-module/evaluate/evaluate.module.ts",
		"common",
		"evaluate-evaluate-module"
	],
	"./statistics-manage/statistics-manage.module": [
		"./src/app/business-module/statistics-manage/statistics-manage.module.ts",
		"common",
		"statistics-manage-statistics-manage-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;